<template>
  <!-- 办件详情 -->
  <div class="main-cont">
    <h3 class="titleh3">办件详情</h3>
    <div class="formDetail-box">
      <ul class="detail-list">
        <li>
          <span>标题</span>
          <span>{{ form.title }}</span>
        </li>
        <li>
          <span>姓名</span>
          <span>{{ form.creator_name | desenName}}</span>
        </li>
        <li>
          <span>手机号码</span>
          <span>{{ form.creator_mobile_number | desenPhone}}</span>
        </li>
        <li>
          <span>邮箱</span>
          <span>{{ form.creator_email }}</span>
        </li>
        <li>
          <span>工作单位</span>
          <span>{{ form.creator_work_organization }}</span>
        </li>
        <li>
          <span>事件发生地</span>
          <span>{{ form.matter_site }}</span>
        </li>
        <li>
          <span>咨询分类</span>
          <span>{{ categoryList.ConsultType[form.consult_type] }}</span>
        </li>
        <li>
          <span>咨询内容</span>
          <span>{{ form.content }}</span>
        </li>
        <li>
          <span>是否公开</span>
          <span>{{ categoryList.IsOnlineSign[form.public_indicant] }}</span>
        </li>
        <li>
          <span>提交对象</span>
          <span>{{ form.accept_unit }}</span>
        </li>
        <li>
          <span>相关材料</span>
          <span
            ><a v-if="form.att_url" :href="BASEURL+'RESOURCE/'+form.att_url" target="_blank"
              >查看相关材料</a
            ></span
          >
        </li>
        <!--        <li>-->
        <!--          <span>是否是会员</span>-->
        <!--          <span>{{-->
        <!--            form.creator_member_indicant === 0 ? '非会员' : '会员'-->
        <!--          }}</span>-->
        <!--        </li>-->
      </ul>
    </div>
    <h3 class="titleh3">处理详情</h3>
    <ul class="detail-list">
      <li>
        <span>办件编号</span>
        <span>{{ form.serial_number }}</span>
      </li>
      <li>
        <span>提交时间</span>
        <span>{{ form.create_time }}</span>
      </li>
      <li>
        <span>处理状态</span>
        <span>{{ categoryList.TransStatus[form.trans_status] }}</span>
      </li>
      <li v-show="form.trans_status === 3">
        <span>处理意见</span>
        <span>{{ trans.opinion }}</span>
      </li>
    </ul>
    <div class="btn-box">
      <a-button type="primary" @click="closeConsultDetail">关闭</a-button>
    </div>
  </div>
</template>

<script>
import { getOneConsultDetail } from '@/api/consult';
export default {
  name: 'consultDetail',
  props: ['id'],
  data() {
    return {
      form: {},
      trans: {},
      categoryList: this.$store.state.category,
    };
  },
  created() {
    this.loadOneConsultDetail();
  },
  methods: {
    async loadOneConsultDetail() {
      if (this.id) {
        let p = { id: this.id };
        this.form = await getOneConsultDetail(p);
        if (this.form.trans_status === 3) {
          const trans_id = this.form.trans_id;
          const trans = this.form.trans.find((v) => v.pkid == trans_id);
          if (trans) {
            this.trans = trans;
          }
        }
        console.log(this.form);
      }
    },
    setCategory(val, arr, type) {
      if (arr && Array.isArray(arr[type])) {
        let name;
        arr[type].map((res) => {
          if (val == res.value) {
            name = res.name;
          }
        });
        return name;
      }
    },
    closeConsultDetail() {
      this.$router.go('-1')
      // window.close();
    },
  },
  filters:{
    // 加密
    desenName(name){
      if(!name){
        return ""
      }
      let str = name.substr(0,1);
      for (let i = 0;i<name.length-1;i++){
        str+="*";
      }
      return str;
    },
    // 电话
    desenPhone(phone){
      if(!phone){
        return ""
      }
      let str = phone.substr(0,3);
      for (let i = 0;i<phone.length-1;i++){
        str+="*";
      }
      return str;
    },
    //身份证号
    desenIdCard(idcard){
      if(!idcard){
        return ""
      }
      let str = idcard.replace(/^(.{4})(?:\w+)(.{4})$/,"\$1****\$2");
      console.log(str)
      return str

    }
  }
};
</script>

<style scoped>
.detail-list {
  border: 1px solid #d9dfe8;
  border-bottom: 0;
  margin: 0;
}

.detail-list li {
  list-style: none;
  display: flex;
  border-bottom: 1px solid #d9dfe8;
  line-height: 2;
}

.detail-list li span:first-child {
  width: 210px;
  text-align: right;
  box-sizing: border-box;
  font-size: 15px;
  color: #666;
  background: #fafbfc;
  position: relative;
  padding: 10px 25px 10px 0;
}

.detail-list li span:nth-child(2) {
  flex: 1;
  font-size: 15px;
  color: #333;
  padding: 10px 25px 10px 20px;
}

.detail-list li i {
  color: #ff0303;
  position: absolute;
  right: 10px;
  top: 2px;
}

.btn-box {
  text-align: center;
  padding: 20px 0;
}
</style>
